import { createApi } from '@reduxjs/toolkit/query/react';
import { axiosBaseQuery } from 'services/api';
import UserLink from 'models/Link';

const USER_LINK_TAG = 'UserLink';

export const userLinkApi = createApi({
  reducerPath: 'userLinkApi',
  baseQuery: axiosBaseQuery({
    apiPath: '/api/user-links/',
  }),
  tagTypes: [USER_LINK_TAG],
  endpoints: builder => ({
    getUserLinks: builder.query({
      query: ({ user }) => ({
        params: { user },
      }),
      transformResponse: response =>
        Array.isArray(response) ? response.map(link => new UserLink(link)) : [],
      providesTags: (result, error, { user }) => [{ type: USER_LINK_TAG, id: user }],
    }),
    updateUserLinksBulk: builder.mutation({
      query: ({ user, data }) => ({
        url: `bulk/?user=${user.id}`,
        method: 'POST',
        data,
      }),
      transformResponse: response =>
        Array.isArray(response) ? response.map(link => new UserLink(link)) : [],
      invalidatesTags: (result, error, { user }) => [{ type: USER_LINK_TAG, id: user.id }],
    }),
  }),
});

export const { useGetUserLinksQuery, useUpdateUserLinksBulkMutation } = userLinkApi;
